import { render, staticRenderFns } from "./ChapterList.vue?vue&type=template&id=b7c7d47a"
import script from "./ChapterList.vue?vue&type=script&lang=js"
export * from "./ChapterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports